import { Box, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Typography from '../../../atoms/typography';
import Input from '../../../atoms/input';
import { useForm } from 'react-hook-form';
import ButtonComponent from '../../../atoms/button';
import { ESTADOS } from '../../../../constants/constants';
import { DistributorForm } from '../../../../services/types';
import usePatchDistributor from '../../../../hooks/distributors/usePatchDistributor';
import { ApplicationState } from '../../../../store';
import { useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import useGetDistributorData from '../../../../hooks/distributors/useGetDistributorData';
import { toast } from 'react-toastify';

const FreightConfiguration: React.FC = () => {
  const { control } = useForm();
  const token = useSelector(
    (state: ApplicationState) => state.auth.token || state.distributor.token,
  );
  const tokenDecoded: any = jwtDecode(token);
  const { execute } = usePatchDistributor();
  const { execute: UseGetDistributor } = useGetDistributorData();
  const [isChanged, setIsChanged] = useState(false);
  const [distributor, setDistributor] = useState<DistributorForm>({
    name: '',
    cnpj: '',
    zipCode: '',
    state: '',
    city: '',
    neighborhood: '',
    streetAddress: '',
    streetNumber: '',
    phone: '',
    fee: '0',
    feeType: 'Percent',
    stateRegistration: ESTADOS[0].sigla,
    percantageLimit: 0,
  });

  const handlePatchDistributor = async () => {
    if (distributor.percantageLimit !== undefined) {
      await execute(distributor.percantageLimit, tokenDecoded.distributorId);
    } else {
      toast.error(
        'O limite percentual de custo de fretes não pode estar vazio.',
      );
    }
  };

  const getDistributorData = async () => {
    if (tokenDecoded.distributorId?.length) {
      const distributorData = await UseGetDistributor(
        tokenDecoded.distributorId,
      );
      setDistributor({
        ...distributorData,
      });
    }
  };

  useEffect(() => {
    getDistributorData();
    return () => {
      setDistributor({
        ...distributor,
      });
    };
  }, []);

  return (
    <Box component="div">
      <Typography color="secondary" fontWeight="bold" lineHeight={24}>
        Configuração de fretes
      </Typography>
      <Grid container spacing={2} style={{ marginTop: 4 }}>
        <Grid item xs={12}>
          <Input
            label={'Limite do percentual de custo fretes'}
            placeholder="11"
            name="percantageLimit"
            control={control}
            maxLength={2}
            value={distributor.percantageLimit}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setDistributor({
                ...distributor,
                percantageLimit: Number(event.target.value),
              });
              setIsChanged(true);
            }}
            endAdornment={'%'}
          />
        </Grid>
      </Grid>

      <Grid container justifyContent="space-between" style={{ marginTop: 20 }}>
        <ButtonComponent
          theme="outline-primary"
          justifyContent="flex-start"
          flex={1}
          onClick={() => window.history.back()}
        >
          Cancelar
        </ButtonComponent>
        <ButtonComponent
          theme="primary"
          justifyContent="flex-end"
          flex={1}
          onClick={handlePatchDistributor}
          disabled={!isChanged}
        >
          Salvar alterações
        </ButtonComponent>
      </Grid>
    </Box>
  );
};

export default FreightConfiguration;
